import {
  SET_HOURS_ENDORSEMENT_COUNT,
  SET_DISCREPANCIES_COUNT,
  SET_HASNOTPRESENTREPORTS_VALUE,
  SET_NOTIFICATIONS_VALUE,
  SET_SECTIONRELOAD_VALUE,
  SET_PYRO_VISIBLE
} from '../constants/Session';

export function setHoursEndorsementCount(count) {
  return {
    type: SET_HOURS_ENDORSEMENT_COUNT,
    count: count
  };
}

export function setDiscrepanciesCount(count) {
  return {
    type: SET_DISCREPANCIES_COUNT,
    count: count
  };
}

export function setHasNotPresentReports(value) {
  return {
    type: SET_HASNOTPRESENTREPORTS_VALUE,
    value: value
  };
}

export function setNotifications(value)
{
  return {
    type: SET_NOTIFICATIONS_VALUE,
    value: value
  };
}

export function setSectionReload(value)
{
  return {
    type: SET_SECTIONRELOAD_VALUE,
    value: value
  };
}

export function setPyroVisible(visible) {
  return {
    type: SET_PYRO_VISIBLE,
    visible: visible
  };
}
